import React, { useState } from 'react';

import ConfirmationButton from 'components/ConfirmationButton';
import Button from 'components/DesignSystem/Button';
import TextFieldComponent from 'components/DesignSystem/TextField';

import type { AgroLocation } from 'types/Meteorology/Agro/getAgroLocations';

import './index.scss';

export default function Location({
  location,
  onEdit,
  onDelete,
}:{
  location: AgroLocation;
  onEdit: (id: number, name: string) => void;
  onDelete: (id: number) => void;
}) {
  const [editMode, setEditMode] = useState(false);
  const [newName, setNewName] = useState(location.name);

  const onSave = () => {
    setEditMode(false);
    onEdit(location.id, newName);
  };

  return (
    <div className="agro-edit-location-name">
      <div>
        {editMode ? (
          <TextFieldComponent
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            className="agro-edit-location-name-input"
          />
        ) : (
          location.name
        )}
      </div>
      <div className="edit-options-buttons">
        {editMode ? (
          <>
            <Button
              type="secondary"
              icon="checkmark"
              onClick={onSave}
              id={`save-location-${location.id}`}
            />
            <Button
              type="secondary"
              icon="close"
              onClick={() => setEditMode(false)}
              id={`cancel-edit-location-${location.id}`}
            />
          </>
        ) : (
          <>
            <Button
              type="secondary"
              icon="edit"
              onClick={() => setEditMode(true)}
              id={`edit-location-${location.id}`}
            />
            <ConfirmationButton
              type="secondary"
              icon="close"
              onClick={() => onDelete(location.id)}
              confirmationBody={(
                <p>
                  Tem certeza que deseja excluir o local
                  <strong>{` ${location.name}`}</strong>
                  ?
                </p>
              )}
              id={`delete-location-${location.id}`}
            />
          </>
        )}
      </div>
    </div>
  );
}
